module.exports = "../images/icon-hunting.svg?v=6963a76";